<template>
  <v-card>
    <v-card-title class="pt-0 pb-0">
      <v-row>
        <v-col cols="12" lg="6">
          <h5>{{ !creditNoteObj.id ? $t('message.invoice.createCreditNote') : $t('message.invoice.creditNote') }} {{ getCreditNoteNumber || '' }}</h5>
          <p v-if="creditNoteObj.integrationerrormessage" class="error--text mb-0">ERP sync failed with error: {{ creditNoteObj.integrationerrormessage }}</p>
        </v-col>
          <v-col cols="12" lg="6" class="text-end">
             <template v-if="!$route.query.from">
            <v-menu top :close-on-content-click="true" v-if="creditNoteObj.status === 'draft'">
              <template v-slot:activator="{ on }">
                <v-btn color="primary" dark v-on="on" :loading="saveLoader" class="mr-2" small>{{$t('message.invoice.saveAs')}}</v-btn>
              </template>
              <v-list>
                <v-list-item v-for="(item, index) in dropdownItems" :key="index" @click="item.callback">
                  <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
          <template v-if="creditNoteObj.status === 'completed'">
            <v-btn color="primary" dark :loading="ehfLoader" small @click="ehfWarningHandler" v-if="isShowResendEhf()">{{ $t('message.invoice.resendEhf') }}</v-btn>
          </template>
          <v-btn color="success" v-if="creditNoteObj.number && !creditNoteObj.external_id" small dark @click="syncToErp" :loading="syncToErpLoading" class="mr-2">Sync to ERP</v-btn>
          <v-btn color="primary" v-if="creditNoteObj.id && isShowResendEmail()" small dark @click="resendDialogEmailHandler" :loading="emailLoader">{{ $t('message.invoice.resendEmail') }}</v-btn>
          <v-btn color="info" class="ml-4" @click="downloadInvoice(false, '')" :loading="previewLoader" v-if="creditNoteObj.id" small>{{$t('message.deviations.downloadPDF') }}</v-btn>
         <v-btn color="warning" class="ml-4" small @click="$router.push(`/orders/edit/${$route.params.order_id}/invoice`)">{{$t('message.common.backToList')}}</v-btn>
          </v-col>
        </v-row>
    </v-card-title>
    <v-progress-linear :active="loading" :indeterminate="loading" absolute color="primary accent-4" v-if="loading"></v-progress-linear>
    <v-divider v-else></v-divider>
    <v-card-text>
      <v-form ref="invoiceForm" onsubmit="return false;">
        <v-row>
          <v-col cols="6">
            <v-row>
              <v-col cols="6" class="pa-1">
                <v-textarea dense hide-details outlined rows="4" readonly v-model="creditNoteObj.invoicetodetail" :label="$t('message.orders.invoiceTo')"></v-textarea>
              </v-col>
              <v-col cols="6" class="pa-1">
                <v-textarea dense hide-details outlined rows="4" readonly v-model="creditNoteObj.orderfordetail" :label="$t('message.orders.orderFor')"></v-textarea>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="6">
            <v-row>
              <v-col cols="12" sm="6" md="4" class="pa-1">
                <v-autocomplete v-model="creditNoteObj.payment_term" :items="listOfPaymentTerms" item-text="name" item-value="days"
                  :label="$t('message.invoice.pmtTerms')" outlined dense hide-details :disabled="disableFields">
                </v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" md="4" class="pa-1">
                <v-menu :close-on-content-click="false" v-model="invoicedDate" transition="scale-transition" offset-y min-width="290px" :disabled="disableFields">
                  <template v-slot:activator="{ on }">
                    <v-text-field outlined hide-details v-model="creditNoteObj.invoice_date" clearable :label="$t('message.invoice.invoicedDate')"
                      prepend-icon="mdi-calendar" readonly v-on="on" @click:clear="$nextTick(() => invoicedDatePicker = null)" dense :disabled="disableFields">
                    </v-text-field>
                    </template>
                    <v-date-picker color="primary" @input="invoicedDate = false" v-model="invoicedDatePicker" :disabled="disableFields"
                      first-day-of-week='1'></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="6" md="4" class="pa-1">
                <v-menu :close-on-content-click="false" v-model="invoiceDueDate" transition="scale-transition" offset-y min-width="290px" :disabled="disableFields">
                  <template v-slot:activator="{ on }">
                    <v-text-field outlined hide-details v-model="creditNoteObj.due_date" clearable :disabled="disableFields"
                      :label="$t('message.invoice.duedate')" prepend-icon="mdi-calendar" readonly v-on="on" @click:clear="$nextTick(() => invoiceDuePicker = null)" dense>
                    </v-text-field>
                    </template>
                    <v-date-picker color="primary" @input="invoiceDueDate = false" v-model="invoiceDuePicker" :disabled="disableFields"
                      first-day-of-week='1'></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="4" class="pa-1">
                <v-menu :close-on-content-click="false" v-model="invoicedCompletedDate" transition="scale-transition" offset-y min-width="290px" :disabled="disableFields">
                  <template v-slot:activator="{ on }">
                    <v-text-field outlined hide-details v-model="creditNoteObj.completed_date" clearable :disabled="disableFields"
                      :label="$t('message.invoice.completedDate')" prepend-icon="mdi-calendar" readonly v-on="on" @click:clear="$nextTick(() => invoicedCompletedPicker = null)" dense></v-text-field>
                    </template>
                    <v-date-picker color="primary" @input="invoicedCompletedDate = false" v-model="invoicedCompletedPicker" :disabled="disableFields"
                      first-day-of-week='1'></v-date-picker>
                  </v-menu>
              </v-col>
              <v-col cols="12" sm="6" md="4" class="pa-1">
                <v-autocomplete v-model="creditNoteObj.deliveryterms_id" :items="listOfDeliveryTerms" item-text="name" item-value="id"
                  :label="$t('message.order.deliveryTerm')" outlined dense hide-details :disabled="disableFields">
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" lg="2" xs="12"  md="3" class="pa-1">
            <v-text-field outlined hide-details dense v-model="creditNoteObj.order_salesreference" :label="$t('message.orders.salesReference')" disabled></v-text-field>
          </v-col>
          <v-col cols="12" lg="2" xs="12"  md="4" class="pa-1">
            <v-text-field v-model="creditNoteObj.order_yourordernumber" outlined dense :label="$t('message.orders.yourOrderNumber')" hide-details
            :disabled="disableFields"></v-text-field>
          </v-col>
          <v-col cols="12" lg="2" xs="12"  md="4" class="pa-1">
            <v-text-field v-model="creditNoteObj.your_reference" outlined dense :label="$t('message.invoice.yourReference')" hide-details :disabled="disableFields"></v-text-field>
          </v-col>
          <v-col cols="12" lg="3" xs="12"  md="4" class="pa-1">
            <v-text-field v-model="creditNoteObj.your_contact" outlined dense :label="$t('message.invoice.yourContact')" hide-details :disabled="disableFields"></v-text-field>
          </v-col>
          <v-col cols="12" lg="3" xs="12"  md="4" class="pa-1">
            <v-autocomplete v-model="creditNoteObj.our_reference" :items="usersList" item-text="name" item-value="id"
              :label="$t('message.invoice.ourReference')" outlined dense hide-details :disabled="disableFields">
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row row wrap>
          <v-flex xs12 sm6 class="pl-2">
            <!-- <v-flex xs12>
              <h4>{{ $t('message.common.comments') }}:</h4>
            </v-flex> -->
            <v-flex xs12>
              <v-textarea v-model="creditNoteObj.tasks_performed" :disabled="disableComments" outlined rows="3" :label="$t('message.common.comments')" hide-details></v-textarea>
              <!-- <ckeditor :editor="editor" v-model="creditNoteObj.tasks_performed" :config="editorConfig"></ckeditor> -->
            </v-flex>
          </v-flex>
          <v-flex xs12 sm6 class="pl-2">
          </v-flex>
        </v-row>
        <v-divider class="mt-1"></v-divider>
        <v-simple-table dense class="dense_table invoiceProducts">
          <template v-slot:default>
            <thead>
              <tr>
                <th :class="header.class" v-for="(header, index) in productHeaders" :key="index">{{header.text}}
                  <span style="color:red"> {{ header.showRequired ? '(*)' : '' }}</span>
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(element, index) in listOfInvoiceItems">
                <tr :key="`${index}_item`" :style="{ background: (element.color ? element.color : ((index  % 2) === 0) ? '#f8f8ff' : '#ededfb')}">
                  <template v v-if="element.newproduct">
                    <td width="8%">
                      <v-text-field v-if="element.productset" @input="resetToprojectSelect(index, element, `searchInput${index}`)" hide-details full-width v-model="element.product_number" :placeholder="$t('message.common.typeHere')"></v-text-field>
                      <v-combobox v-else v-model ="element.product" :items="element.products" autocomplete="off"
                        @keyup="$event.keyCode !== 13 ? loadProducts(`searchInput${index}`, index, $event) : ''"
                        :ref="`searchInput${index}`"
                        @change="setProductValues(index, element.product)"
                        @click="toggleAllProducts(index, SHOW)"
                        @focusout="toggleAllProducts(index, HIDE, element.productid)"
                        item-text="productName" item-value="id" :rules="$_requiredValidation"
                        hide-details full-width :placeholder="$t('message.common.typeHere')"
                        :loading="productsLoading"></v-combobox>
                    </td>
                    <td width="19%">
                      <v-text-field v-model="element.description" hide-details full-width :placeholder="$t('message.common.typeHere')" class="commentsArea textfieldstyle">
                         <template v-slot:append>
                          <v-icon class="mt-0" :disabled="element.newproduct ? false : !!element.comments" @click.stop="hideAndShowComments(element, index)">mdi-comment-text</v-icon>
                        </template>
                      </v-text-field>
                    </td>
                  </template>
                  <template v-else>
                    <td width="8%" v-if="element.product_number">
                      <v-text-field hide-details full-width readonly v-model="element.product_number"></v-text-field>
                    </td>
                    <td width="8%" v-else>
                      <v-text-field hide-details full-width  :readonly="element.is_hour_or_usedproduct ? true : false" v-model="element.number" max="10" :disabled="disableFields"></v-text-field>
                    </td>
                    <td width="19%">
                      <v-text-field v-model="element.description" hide-details full-width :placeholder="$t('message.common.typeHere')" :readonly="creditNoteObj.status === 'draft'" :disabled="creditNoteObj.status === 'draft' ? false : disableFields" class="commentsArea textfieldstyle">
                        <template v-slot:append>
                          <v-icon class="mt-0" :disabled="creditNoteObj.status !== 'draft'" @click.stop="hideAndShowComments(element, index)">mdi-comment-text</v-icon>
                        </template>
                      </v-text-field>
                    </td>
                  </template>
                  <td width="6%">
                    <template v-if="!element.product_isinformation">
                      <v-text-field v-model="element.qty" hide-details full-width :placeholder="$t('message.common.typeHere')"
                        class="align-right" @change="doCalculation(index)" :disabled="element.newproduct ? false : disableFields">
                      </v-text-field>
                    </template>
                  </td>
                  <td width="5%">
                    <template v-if="!element.product_isinformation">
                      <v-select v-model="element.unit_id" :disabled="element.newproduct ? false : disableFields" :items="listOfUnits" item-text="name" item-value="id" class="align-right" hide-details full-width></v-select>
                    </template>
                  </td>
                  <td width="7%">
                    <template v-if="!element.product_isinformation">
                      <v-text-field v-model="element.net_price" hide-details full-width :placeholder="$t('message.common.typeHere')" class="align-right"
                        @change="doCalculation(index)" :disabled="element.newproduct ? false : disableFields">
                      </v-text-field>
                    </template>
                  </td>
                  <td width="7%">
                    <template v-if="!element.product_isinformation">
                      <v-text-field v-model="element.base_price" hide-details full-width :placeholder="$t('message.common.typeHere')" class="align-right"
                        @change="doCalculation(index)" :disabled="element.newproduct ? false : disableFields">
                      </v-text-field>
                    </template>
                  </td>
                  <td width="6%">
                    <template v-if="!element.product_isinformation">
                      <v-text-field v-model="element.discount" hide-details full-width :placeholder="$t('message.common.typeHere')"
                        class="align-right" @change="doCalculation(index)" :disabled="element.newproduct ? false : disableFields">
                      </v-text-field>
                    </template>
                  </td>
                  <td width="8%">
                    <template v-if="!element.product_isinformation">
                      <v-text-field v-model="element.sum_ex_vat" class="align-right" readonly hide-details full-width></v-text-field>
                    </template>
                  </td>
                  <td width="6%">
                    <template v-if="!element.product_isinformation">
                      <v-select v-model="element.vat" @change="doCalculation(index)" class="align-right" item-text="text" item-value="value" :disabled="element.newproduct ? false : disableFields" hide-details :items="listOfVAT"></v-select>
                    </template>
                  </td>
                  <td width="8%">
                    <template v-if="!element.product_isinformation">
                      <v-text-field v-model="element.price" readonly hide-details full-width :placeholder="$t('message.common.typeHere')"
                        class="align-right" :disabled="element.newproduct ? false : disableFields">
                      </v-text-field>
                    </template>
                  </td>
                  <td width="8%" class="text-right">
                    <template v-if="!element.product_isinformation">
                      {{ element.cost }}
                    </template>
                  </td>
                  <td width="7%" class="text-right">
                    <template v-if="!element.product_isinformation">
                      {{ element.db }}
                    </template>
                  </td>
                  <td width="7%" class="text-right">
                    <template v-if="!element.product_isinformation">
                      {{ element.dg }}
                    </template>
                  </td>
                  <td v-if="element.newproduct" style="background: white;border-bottom:none !important;">
                    <v-btn elevation="0" max-width="18" max-height="18" fab dark x-small color="primary" class="ml-1 mb-2" @click="deleteRow(index)"><!-- listOfInvoiceItems.splice(index, 1) -->
                      <v-icon dark size="16">mdi-minus</v-icon>
                    </v-btn>
                  </td>
                </tr>
                <tr v-if="creditNoteObj.status === 'draft' ? element.show_comments : !!element.comments" :key="`${index}_comments`"><!-- element.newproduct ? element.show_comments : !!element.comments -->
                  <td :colspan="9" class="pa-1 pl-0 pr-0">
                    <v-textarea :rows="1" auto-grow class="credit_note_comment mt-1" hide-details outlined v-model="element.comments"
                    :disabled="creditNoteObj.status === 'draft' ? false : disableFields"></v-textarea>
                  </td>
                  <td :colspan="4">
                  </td>
                </tr>
                <tr v-if="element.loading" :key="`${index}_row-loader`">
                  <td :colspan="productHeaders.length" class="pa-0" style="border-bottom: none !important;height:auto !important;">
                    <v-progress-linear
                      indeterminate
                      color="primary"
                    ></v-progress-linear>
                  </td>
                </tr>
                <!-- Commented by vinoth
                  <tr :style="{ background: element.selected ? '#80808038' : element.color }" :key="`${index}_comments`" v-if="element.comments">
                  <td colspan="9" class="pa-1 pl-0 pr-0">
                    <v-textarea :rows="0" :disabled="element.newproduct ? false : disableFields" auto-grow class="comments_invoice mt-1" hide-details outlined v-model="element.comments"></v-textarea>
                  </td>
                  <td colspan="4">
                    <v-btn class="mx-2" text fab dark small color="primary" @click="removeFromGroup(element)" :disabled="disableFields">
                      <v-icon dark>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </td>
                </tr> -->
              </template>
            </tbody>
            <tfoot>
                <tr>
                  <td colspan="6"></td>
                  <td class="text-right" style="padding: 0 2px"><b>{{ $t('message.invoice.sum') }}</b></td>
                  <td class="text-right" style="padding: 0 2px"><b>{{ totalValues.sum }}</b></td>
                  <td class="text-right" style="padding: 0 2px"><b>{{ totalValues.mva }}</b></td>
                  <td class="text-right" style="padding: 0 2px"><b>{{ totalValues.invoiceTotal }}</b></td>
                  <td class="text-right" style="padding: 0 2px"><b>{{ totalValues.cost }}</b></td>
                  <td class="text-right" style="padding: 0 2px"><b>{{ totalValues.db }}</b></td>
                  <td class="text-right" style="padding: 0 2px"><b>{{ totalValues.dg_percentage }}</b></td>
                </tr>
            </tfoot>
          </template>
        </v-simple-table>
        <v-row row wrap v-if="creditNoteObj.status === 'completed'">
          <v-col cols="12" v-if="creditNoteObj.completion_type === 2">
            <span class="subtitle-1 font-weight-bold">{{ $t('message.invoice.creditNoteDownloadedBy',
               { user: creditNoteObj.invoicedownloadedbyname || '',
                date: $formatter.formatDate(creditNoteObj.invoicedownloadedon, 'DD.MM.YYYYTHH:mm:ss', 'DD.MM.YYYY HH:mm:ss') }) }}
            </span>
          </v-col>
          <v-col cols="12" v-else-if="creditNoteObj.completion_type === 3 && creditNoteObj.ehfsentcount >= 1">
            <span class="subtitle-1 font-weight-bold">{{ $t('message.invoice.creditNoteEHFBy',
               { user: creditNoteObj.ehfsentbyname || '',
                date: $formatter.formatDate(creditNoteObj.ehfsenton, 'DD.MM.YYYYTHH:mm:ss', 'DD.MM.YYYY HH:mm:ss') }) }}
            </span>
          </v-col>
          <v-col cols="12" v-else>
            <span class="subtitle-1 font-weight-bold">{{$t('message.invoice.creditNoteCreatedBy')}} {{ creditNoteObj.user_firstname || ''}} {{ creditNoteObj.user_lastname || ''  }} {{this.$t('message.invoice.onDate')}} {{ $formatter.formatDate(creditNoteObj.modified_on, 'DD.MM.YYYYTHH:mm:ss', 'DD.MM.YYYY HH:mm:ss')}}</span>
          </v-col>
          <v-col cols="12" v-if="(creditNoteObj.completion_type === 4 || creditNoteObj.completion_type === 2) && creditNoteObj.invoiceemailedby">
            <span class="subtitle-1 font-weight-bold">{{ $t('message.invoice.creditNoteEmailedBy',
               { user: creditNoteObj.invoiceemailedbyname || '',
                email: creditNoteObj.invoiceemailedto || '',
                date: $formatter.formatDate(creditNoteObj.invoiceemailedon, 'DD.MM.YYYYTHH:mm:ss', 'DD.MM.YYYY HH:mm:ss') }) }}
            </span>
          </v-col>
          <v-col cols="12" v-if="creditNoteObj.invoice_number">
            <span class="subtitle-1 font-weight-bold">{{$t('message.invoice.createdFrom')}} {{creditNoteObj.invoice_number}} {{$t('message.invoice.by')}}  {{ creditNoteUserName }} {{this.$t('message.invoice.onDate')}} {{ $formatter.formatDate(creditNoteObj.invoice_modified_on, 'DD.MM.YYYYTHH:mm:ss', 'DD.MM.YYYY HH:mm:ss')}}</span>
          </v-col>
        </v-row>
      </v-form>
      <v-row class="mx-0 mt-1" v-if="creditNoteObj.status === 'draft'">
        <v-btn max-width="22" max-height="22" fab dark x-small color="primary" class="mr-1 mb-2" @click="addNewProduct">
          <v-icon dark size="18">mdi-plus</v-icon>
        </v-btn>
      </v-row>
    </v-card-text>
    <v-divider></v-divider>
    <v-dialog v-model="showEmailDialog" max-width="500px">
      <v-form ref="emailForm" onsubmit="return false;">
        <v-card>
          <v-card-title>
            {{$t('message.unimicro.sendReport')}}
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="mt-4">
            <v-text-field outlined textarea :label="$t('message.invoice.invoiceEmail')" v-model="emailIds" :rules="$_requiredValidation" hide-details></v-text-field>
            <span>{{ $t('message.common.multiEmailHint') }}</span>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" @click="saveAndEmailHandler(4)" :loading="saveLoader">{{$t('message.common.send')}}</v-btn>
            <v-btn color="error" @click.stop="showEmailDialog=false">{{$t('message.common.close')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <!-- Share Dialog -->
    <v-dialog v-model="shareDialog" persistent max-width="1150px" class="mt-0">
      <v-form ref="shareForm" onSubmit="return false;">
        <v-card>
          <v-card-title>
            {{ $t('message.order.sendCredit') }}
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pa-2">
            <v-col cols="12">
              <v-row>
                <v-text-field outlined dense v-model="emailIds" ref="autoFocus" :label="$t('message.customer.email')" :rules="$_requiredValidation"
                  persistent-hint :hint="$t('message.common.add_extra_mails')"></v-text-field>
              </v-row>
              <v-row>
                <v-text-field outlined dense v-model="subject" ref="autoFocus" :rules="$_requiredValidation"
                  persistent-hint :label="$t('message.tickets.subject')"></v-text-field>
              </v-row>
              <v-row>
                <v-flex xs12>
                  <label class="subtitle-1">{{ $t('message.tickets.body') }}</label>
                  <ckeditor :editor="editor" v-model="body" :config="editorConfig"></ckeditor>
                </v-flex>
              </v-row>
              <v-row>
                <v-checkbox dense :label="$t('message.common.copy_to_me')" v-model="isCopyToMe" hide-details color="primary"></v-checkbox>
              </v-row>
              <v-row>
                <attach_share v-model="filelist" v-if="shareDialog" :filelist="filelist" :sharepoint="attachmentSharepointObj"></attach_share>
              </v-row>
            </v-col>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" id="sendMail" :loading="saveLoader" @click="isResend ? resendEmailHandler() : saveAndEmailHandler(4)">{{ $t('message.common.send') }}</v-btn>
            <v-btn color="error" id="close" @click="closeShareDialog">{{ $t('message.common.close') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
     <!-- Confirmation about EHF -->
     <v-dialog v-model="ehfWarningObj.dialog" width="400" persistent>
      <v-card>
        <v-card-title>
          {{$t('message.invoice.confirmation')}}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-4">
          {{$t('message.invoice.likeToSendEHF')}}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-layout>
            <v-flex class="text-center">
              <v-btn color="primary" :loading="ehfWarningObj.loading" @click="ehfWarningObj.onSuccess" class="mr-3"> {{$t('message.common.yes')}}</v-btn>
              <v-btn color="error" @click="ehfWarningObj.onCancel"> {{$t('message.common.no')}}</v-btn>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Error Dialog -->
    <v-dialog v-model="errorDialog" width="500" persistent>
      <v-card>
        <v-card-title class="error white--text">
          {{$t('message.order.errorOccurred') || 'Error'}}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-4">
          <p class="error--text">{{ errorMessage }}</p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="closeErrorDialog">{{$t('message.common.close')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
/* eslint-disable */
import { mapState } from 'vuex'
import Nordea from '@/mixins/InvoiceNordea/index'
import moment from 'moment'
import { getCreditNoteTemplate } from '@/constants'
import Editor from '@/ckeditor'
export default {
  data () {
    return {
      creditNoteObj: {
        id: this.$route.params.invoice_id ? this.$route.params.invoice_id : 0,
        invoice_date: '',
        due_date: '',
        completed_date: '',
        payment_term: 0,
        status: 'draft'
      },
      disableFields: true,
      disableComments: false,
      invoicedDatePicker: null,
      invoiceDuePicker: null,
      invoicedCompletedPicker: null,
      invoicedDate: false,
      invoiceDueDate: false,
      invoicedCompletedDate: false,
      dropdownItems: [
        // { text: this.$t('mess      <h5>{{ !creditNoteObj.id ? $t('message.invoice.createCreditNote') : $t('message.invoice.creditNote') }}</h5>age.invoice.saveAsDraft'), id: 0, callback: () => this.saveAsHandler(1) },
        { text: this.$t('message.invoice.saveAndEmail'), id: 2, callback: () => this.saveAsHandler(4, '') },
        { text: this.$t('message.invoice.saveAndDownloadPDF'), id: 2, callback: () => this.saveAsHandler(2) }
      ],
      pmtTermsList: [
        { text: `7 ${this.$t('message.invoice.days')}`, value: 7 },
        { text: `10 ${this.$t('message.invoice.days')}`, value: 10 },
        { text: `14 ${this.$t('message.invoice.days')}`, value: 14 },
        { text: `30 ${this.$t('message.invoice.days')}`, value: 30 }
      ],
      saveButton: [],
      listOfInvoiceItems: [],
      totalValues: {},
      saveLoader: false,
      loading: false,
      listOfCustomers: [],
      previewLoader: false,
      listOfSearchedProducts: [],
      activeProduct: '',
      MODULE: 'invoices',
      vatList: [],
      ehfLoader: false,
      emailIds: '',
      listOfOrderChecklist: [],
      usersList: [],
      showEmailDialog: false,
      listOfUnits: [],
      initSaveWithIds: false,
      creditNoteUserName: '',
      listOfAllOrderedChecklist: [],
      listOfVAT: [{
        text: '0%',
        value: 0
      }, {
        text: '12%',
        value: 12
      }, {
        text: '25%',
        value: 25
      }],
      settingsObj: {},
      editor: Editor,
      editorConfig: {
        toolbar: {
          items: [
            'heading',
            '|',
            'bold',
            'italic',
            '|',
            'bulletedList',
            'numberedList',
            '|',
            'undo',
            'redo'
          ]
        }
      },
      exchangeRate: 0,
      productsLoading: false,
      partialCreditIds: null,
      shareDialog: false,
      subject: '',
      body: '',
      isCopyToMe: false,
      attachmentSharepointObj: {
        loading: false,
        files: []
      },
      filelist: [],
      emailLoader: false,
      syncToErpLoading: false,
      ehfWarningObj: {
        dialog: false,
        loading: false,
        onSuccess: () => false,
        onCancel: () => false
      },
      errorDialog: false,
      errorMessage: ''
    }
  },
  watch: {
    invoicedDatePicker (val) {
      if (val) {
        this.creditNoteObj.invoice_date = this.$formatter.formatDate(val, 'YYYY-MM-DD', 'DD.MM.YYYY')
      }
    },
    'shareDialog' (val) {
      this.attachmentSharepointObj.files = []
      if (val) {
        if (this.creditNoteObj.order_sharepoint_id) this.getAllDocumentsFromSharepointForShare(this.creditNoteObj.order_sharepoint_id)
        this.filelist = []
        const { mail_subject, creditnote_mail_body, mail_signature } = this.$formatter.cloneVariable(this.settingsObj)
        this.subject = mail_subject
        this.body = `${creditnote_mail_body} ${mail_signature}`
        // let mailTemplate = getCreditNoteTemplate(this.creditNoteObj);
        // this.subject = mailTemplate.subject
        // this.body = mailTemplate.body
      }
    }
  },
  mixins: [Nordea],
  components: {
    'attach_share': () => import('@/components/AttachFileToMail.vue')
  },
  computed: {
     ...mapState(['listOfUsers', 'listOfPaymentTerms', 'listOfDeliveryTerms']),
    productHeaders: {
     get () {
        const heads = [{
          text: this.$t('message.warehouse.product'),
          value: 'product_number',
          width: '6%',
          reportWidth: '8%',
          class: 'text-left'
        }, {
          text: this.$t('message.customer.description'),
          value: 'description',
          reportWidth: '20%',
          width: '10%',
          class: 'text-left'
        }, {
          text: this.$t('message.invoice.qty'),
          value: 'qty',
          showRequired: true,
          reportWidth: '8%',
          width: '5%',
          class: 'text-right'
        }, {
          text: this.$t('message.product.unit'),
          value: 'productunit_name',
          reportWidth: '7%',
          width: '5%',
          class: 'text-right'
        }, {
          text: this.$t('message.product.costPrice'),
          value: 'cost_price',
          showRequired: true,
          reportWidth: '10%',
          width: '10%',
          class: 'text-right'
        }, {
          text: this.$t('message.product.salesPrice'),
          showRequired: true,
          value: 'base_price',
          reportWidth: '10%',
          width: '10%',
          class: 'text-right'
        }, {
          text: this.$t('message.product.discount'),
          value: 'discount',
          width: '6%',
          reportWidth: '7%',
          class: 'text-right'
        }, {
          text: this.$t('message.invoice.sumeksMva'),
          value: 'sum_ex_vat',
          width: '11%',
          reportWidth: '12%',
          class: 'text-right'
        }, {
          text: `${this.$t('message.customer.vatValue')} %`,
          value: 'vat',
          width: '6%',
          reportWidth: '7%',
          class: 'text-right'
        }, {
          text: this.$t('message.invoice.priceIncVat'),
          value: 'price',
          width: '11%',
          reportWidth: '12%',
          class: 'text-right'
        }, {
          text: this.$t('message.document.cost'),
          value: 'cost',
          width: '10%',
          class: 'text-right'
        }, {
          text: 'DB',
          value: 'db',
          width: '10%',
          class: 'text-right'
        }, {
          text: 'DG',
          value: 'dg',
          width: '10%',
          class: 'text-right'
        }]
        this.headersForInvoiceItems = heads
        return this.headersForInvoiceItems
      },
      set (value) {
        this.headersForInvoiceItems = value
      }
    },
    getCreditNoteNumber (){
      return this.creditNoteObj.number || ''
    },
  },
  mounted () {
    let partialCreditIds = window.localStorage.getItem('#credit_note_select_products')
    if (partialCreditIds) this.partialCreditIds = JSON.parse(partialCreditIds)
    this.getUsersList()
    if (this.$route.params.invoice_id) {
      this.getSingleRecordHandler()
    } else if (this.$route.query.invoice_id) {
      this.getSingleRecordHandler(true)
    } else {
      this.getCustomers('isactive eq 1')
    }
    this.getInvoiceSettings()
    this.$store.dispatch('getPaymentTerms', this.$t('message.common.days'))
    this.$store.dispatch('getDeliveryTerms')
  },
  methods: {
    getCustomers (filter, customerId) {
      let query = {
        select: ['id', 'name', 'paymentmethod1', 'paymentmethod2', 'email', 'invoiceemail', 'vat'],
        filter: filter,
        order_by: { field: 'name', asc_or_desc: 'asc' }
      }
      this.$_executeApi('post', 'customers/query', query).then(async (response) => {
        this.listOfCustomers = response.data
        // && this.creditNoteObj.completion_type === 3
        if (customerId) {
          let result = this.listOfCustomers.find(x => x.id === customerId)
          if (result && !this.dropdownItems.some(item => item.id === 1)) {
            if (result.paymentmethod2 === '2') {
              const organizationExists = await this.$_checkOrganzationExistsInElma(result.vat)
              if (organizationExists) {
                this.dropdownItems.splice(1, 0, { text: this.$t('message.invoice.saveAndUseEHF'), id: 1, callback: () => this.saveAsHandler(3) })
              }
            }
          }
        }
      })
    },
    getUsersList (obj) {
      this.$store.dispatch('getUsers', obj)
        .then((result) => {
          // getting users
          let detailsData = this.creditNoteObj.ourreferencedata ? JSON.parse(this.creditNoteObj.ourreferencedata) : {}
          this.usersList = result
          this.usersList.map(x => {
            if (x.id === this.creditNoteObj.our_reference && this.creditNoteObj.ourreferencedata) {
              let referenceDetail = [detailsData.FirstName || '', detailsData.LastName || '']
              x.name = referenceDetail.filter(y => y).join(' ')
            } else {
              let referenceDetail = [x.firstname || '', x.lastname || '']
              x.name = referenceDetail.filter(y => y).join(' ')
            }
            return x
          })
        })
    },
    doCalculation (index) {
      let item = this.$formatter.cloneVariable(this.listOfInvoiceItems)
      if (item[index].qty != null && item[index].qty != '' && item[index].base_price != null && item[index].base_price != '') {
        let model = this.$formatter.formatAndParseModel(item[index], ['qty', 'base_price', 'net_price', 'sum_ex_vat', 'price', 'discount', 'db', 'cost', 'dg'], 'replaceCommaWithDot')
        let total =  model.base_price *  model.qty * (1 - (model.discount || 0) / 100)
        model.sum_ex_vat = total
        let vatValue = (model.vat || 0) / 100
        model.price = total * (1 + vatValue)
        if (model.qty) {
          let getProp = model.is_hour_or_usedproduct ? 'entered_qty' : 'qty'
          model.cost = (model.net_price || 0) * model[getProp]
          model.db =  model.sum_ex_vat - model.cost
        }
        model.dg = (model.db * 100) / model.sum_ex_vat
        let transformData = { number: { list: ['qty', 'base_price', 'net_price', 'discount', 'sum_ex_vat', 'price', 'db', 'cost', 'dg'], format: 'replaceDotWithComma' } }
        model = this.$_formatModel(model, transformData)
        this.$set(this.listOfInvoiceItems, index, model)
        this.calculateAllValues()
        this.$store.commit('isChangesMade', true)
      }
    },
    calculateAllValues () {
      let listOfProducts = this.$formatter.cloneVariable(this.listOfInvoiceItems)
      listOfProducts = this.$formatter.formatAndParseList(listOfProducts, ['qty', 'base_price', 'price', 'discount', 'sum_ex_vat', 'cost', 'db', 'dg'], 'replaceCommaWithDot')
      let totalValues = { sum: 0, mva: 0, invoiceTotal: 0, vat: 25, cost: 0, db: 0, dg: 0, dg_percentage: 0 }
      let calculateMVA = 0
      listOfProducts.forEach(element => {
        totalValues.sum += element.sum_ex_vat ? this.$formatter.getRoundedNumberWithPrecision(element.sum_ex_vat) : 0
        totalValues.cost += element.cost ? this.$formatter.getRoundedNumberWithPrecision(element.cost) : 0
        totalValues.db += element.db ? this.$formatter.getRoundedNumberWithPrecision(element.db) : 0
        calculateMVA += this.$formatter.getRoundedNumberWithPrecision((((element.sum_ex_vat || 0) * (element.vat || 0)) / 100))
      })
      // make sure we round with 2 decimal
      totalValues.sum = this.$formatter.getRoundedNumberWithPrecision(totalValues.sum)
      totalValues.mva = this.$formatter.getRoundedNumberWithPrecision(calculateMVA)
      totalValues.db = this.$formatter.getRoundedNumberWithPrecision(totalValues.db)
      totalValues.cost = this.$formatter.getRoundedNumberWithPrecision(totalValues.cost)

      totalValues.dg = ((totalValues.db * 100) / (totalValues.sum))

      let grandTotal = this.$formatter.getRoundedNumberWithPrecision(totalValues.sum + totalValues.mva)
      var roundOffValue = this.$formatter.getRoundedNumberWithPrecision(grandTotal, 0) - grandTotal
      totalValues.rounding_value = roundOffValue

      totalValues.invoiceTotal = grandTotal // Math.ceil(grandTotal)
      totalValues.dg_percentage = -totalValues.dg
      let transformData = { number: { list: ['sum', 'mva', 'invoiceTotal', 'cost', 'db', 'rounding_value' , 'dg_percentage'], format: 'replaceDotWithComma' } }
      totalValues = this.$_formatModel(totalValues, transformData)
      this.totalValues = totalValues
    },
    removeRowHandler (index) {
      if (this.listOfInvoiceItems.length > 1) {
        this.listOfInvoiceItems.splice(index, 1)
        this.calculateAllValues()
      }
    },
    getSingleRecordHandler (fromInvoice) {
      let id = !fromInvoice ? this.$route.params.invoice_id : this.$route.query.invoice_id
      let query = {
        expand: [ {
          'select': ['firstname', 'lastname'],
          'model': 'User',
          'on_field': 'Id',
          'on_parent_field': 'Modified_By'
        }, {
          'select': ['firstname', 'lastname'],
          'model': 'User',
          'on_field': 'id',
          'on_parent_field': 'ehfsentby'
        }, {
          'select': ['number', 'Modified_By', 'Modified_On'],
          'model': 'Invoice',
          'on_field': 'Id',
          'on_parent_field': 'Invoice_Ref'
        }, {
          'select': ['salesreference', 'sharepoint_id', 'yourordernumber'],
          'model': 'Order',
          'on_field': 'id',
          'on_parent_field': 'order_id'
        }],
        filter: `id eq ${id}`
      }
      this.loading = true
      this.$_executeApi('post', `${this.MODULE}/query`, query).then((response) => {
        if (response && response.data) {
          let creditNoteObj = response.data[0]
          this.creditNoteUserName = `${creditNoteObj.user_firstname || ''} ${creditNoteObj.user_lastname || ''}`
          let transformData = { date: { list: ['invoice_date', 'due_date', 'completed_date'], from: 'DD.MM.YYYYTHH:mm:ss', to: 'DD.MM.YYYY' }, number: { list: ['total_sum', 'grand_total', 'invoiceTotal', 'rounding_value' , 'dg_percentage'], format: 'replaceCommaWithDot' } }
          let model = this.$formatter.cloneVariable(creditNoteObj)
          model = this.$_formatModel(model, transformData)
          this.getCustomers(`isactive eq 1 or id eq ${model.customer_id}`, model.customer_id)
          this.getUsersList({ id: [ model.our_reference ] })
          model.invoicetodetail = model.invoicetodetail ? model.invoicetodetail.replace(/<br\s*[\/]?>/gi, '\n') : ''
          model.orderfordetail = model.orderfordetail ? model.orderfordetail.replace(/<br\s*[\/]?>/gi, '\n') : ''
          model.number = fromInvoice ? model.number = '' : model.number
          if (!model.tasks_performed) model.tasks_performed = ''
          if (!model.comments) model.comments = ''
          this.creditNoteObj = model
          /* get currency Id from currency obj */
          if (this.creditNoteObj.currencydata) {
            let currency = JSON.parse(this.creditNoteObj.currencydata)
            if (currency && currency.Id) this.getExchangeRate(currency.Id)
          }
          /*  */
          this.getInvoiceItems(model.id, fromInvoice)
          if (this.$route.query.invoice_id) {
            this.creditNoteObj.id = 0
            this.creditNoteObj.type = 2
            this.creditNoteObj.status = 'draft'
            this.creditNoteObj.invoice_date = this.$formatter.getTodayInUserFormat()
            this.creditNoteObj.due_date = moment(this.creditNoteObj.invoice_date, 'DD.MM.YYYY', 'DD.MM.YYYY').add(model.payment_term, 'days').format('DD.MM.YYYY')
          }
          if (this.creditNoteObj.status !== 'draft') {
            this.disableFields = true
            this.disableComments = true
          }
        }
      })
    },
    async resendDialogEmailHandler () {
      var emailId = ''
      let result = this.listOfCustomers.find(x => x.id === this.creditNoteObj.customer_id)
      if (result) emailId = result.invoiceemail ? result.invoiceemail : ''
      this.emailIds = emailId
      this.isResend = true
      this.shareDialog = true
    },
    async resendEmailHandler () {
      if (this.$refs.shareForm.validate() && this.emailIds) {
        if (this.emailIds) this.isValidEmail = true
        const getMailIDsString = this.emailIds
        const listOfMailIds = getMailIDsString.split(',')
        if (listOfMailIds.length > 0) {
          for (let i = 0; i < listOfMailIds.length; i++) {
            if (listOfMailIds[i]) {
              listOfMailIds[i] = listOfMailIds[i].trim()
              if (this.validEmail(listOfMailIds[i])) this.isValidEmail = false
              else this.isValidEmail = true
            }
          }
        }
        if (!this.isValidEmail) {
          this.saveLoader = true
          await this.sendEmailHandler(listOfMailIds)
          this.saveLoader = false
        } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    },
    async sendEmailHandler (emailId) {
      if (emailId) {
        await this.downloadInvoice(true, emailId)
      }
    },
    getInvoiceItems (id, fromInvoice) {
      this.listOfUnits = []
      if (id) {
        this.loading = true
        let query = {
          'filter': `invoice_id eq ${id}`,
          'expand': [{
            'select': ['number', 'name', 'unitId', 'isinformation'],
            'model': 'Product',
            'on_field': 'Id',
            'on_parent_field': 'Product_Id'
          }, {
            'select': ['name'],
            'model': 'ProductUnit',
            'on_field': 'Id',
            'on_parent_field': 'Unit_Id'
          }],
          'order_by': {
            field: 'order_index',
            asc_or_desc: 'asc'
          }
        }
        this.$_executeApi('post', `productunits/query`, { filter: 'isactive eq 1' }).then(resposnse => {
          this.listOfUnits = resposnse.data
          this.$_executeApi('post', `invoiceitems/query`, query).then((response) => {
            if (response.data.length > 0) {
              let model = response.data
              /* get the partialcreditids and filter only those */
              model = model.filter(x => !x.iscredited)
              if (this.partialCreditIds && this.partialCreditIds.length) { model = model.filter(x => this.partialCreditIds.includes(x.id)) }
              /* --- */
              if (this.$route.query.invoice_id) {
                this.initSaveWithIds = true // in order to keep the up ID for parent child logic on CREDIT NOTE
              } else {
                this.initSaveWithIds = false
              }
              model.forEach((element, index) => {
                element.show_comments = !!element.comments
                element.id = (this.initSaveWithIds || this.$route.query.materials || this.$route.params.invoice_id) ? element.id : 0
                element.qty = (this.$formatter.replaceDotWithComma(this.initSaveWithIds ? -element.qty : element.qty))
                element.dg = (this.$formatter.replaceDotWithComma(this.initSaveWithIds ? -element.dg : element.dg))
                element.discount = (this.$formatter.replaceDotWithComma(this.initSaveWithIds ? -element.discount : element.discount))
                element.net_price = this.$formatter.replaceDotWithComma(element.net_price)
                element.base_price = this.$formatter.replaceDotWithComma(element.base_price)
                element.sum_ex_vat = (this.$formatter.replaceDotWithComma(this.initSaveWithIds ? -element.sum_ex_vat : element.sum_ex_vat))
                element.price = (this.$formatter.replaceDotWithComma(this.initSaveWithIds ? -element.price : element.price))
                element.cost = (this.$formatter.replaceDotWithComma(this.initSaveWithIds ? -element.cost : element.cost))
                element.db = (this.$formatter.replaceDotWithComma(this.initSaveWithIds ? -element.db : element.db))
                if (element.isextrarow && !element.product_id && element.productnumber) element.product_number = element.productnumber
              })
              this.listOfInvoiceItems = model
              this.calculateAllValues()
            }
            if (this.partialCreditIds && this.creditNoteObj.status === 'draft') this.$store.commit('isChangesMade', true)
            this.loading = false
          })
        })
        .catch(() => {
          this.loading = false
        })
      } else this.loading = false
    },
    async downloadInvoice (fromSendEmail, emailId) {
      this.previewLoader = true
      let getBase64Content = await this.getInvoiceReportContent()
      const customer = this.creditNoteObj.customerdata ? JSON.parse(this.creditNoteObj.customerdata || {}) : {}
      const customerLang = customer.Language ? customer.Language : this.$i18n.locale
      let lang = this.$i18n.messages[customerLang].message
      let model = { content: getBase64Content, filename: `${lang.invoice.creditNote}_${this.creditNoteObj.number || ''}.pdf` }
      await this.$_executeApi('post', `invoices/generate_pdf/${this.creditNoteObj.id}`, model)
        .then(async (response) => {
          let fileName = response.data
          if (!fromSendEmail) {
            window.open(`${process.env.VUE_APP_URL}file/download/?fileName=${fileName}`, '_blank')
          } else {
            const orderdata = this.creditNoteObj.orderdata ? JSON.parse(this.creditNoteObj.orderdata || {}) : {}
            if (this.subject) {
              this.subject = this.subject
                .replace('{{invoice_number}}', this.creditNoteObj.number || '')
                .replace('{{your_reference}}', this.creditNoteObj.your_reference || '')
                .replace('{{your_order_number}}', orderdata.YourOrderNumber || '')
            }
            if (this.body) {
              this.body = this.body
                .replace('{{invoice_number}}', this.creditNoteObj.number || '')
                .replace('{{your_reference}}', this.creditNoteObj.your_reference || '')
                .replace('{{your_order_number}}', orderdata.YourOrderNumber || '')
            }
            let currentUserMail = this.$store.state.userDetails ? this.$store.state.userDetails.email : ''
            let model = {
              'to': emailId,
              'subject': this.subject,
              'filename': fileName,
              'body': this.body,
              'cc': this.isCopyToMe && currentUserMail ? [currentUserMail] : [],
              'visiblefilename': `Kreditnota_${this.creditNoteObj.number || ''}.pdf`
            }
            // upload files to local for share attachments
            const formData = new FormData()
            const files = this.filelist
            files.forEach(file => {
              if (!file.is_sharepoint) {
                formData.append(file.name, file)
              } else {
                formData.append(file.id, file)
              }
            })
            if (files && files.length > 0) {
              await this.$_executeApi('post', `warehouseorders/attachment_upload/${this.creditNoteObj.id}/INVOICE`, formData)
            }
            return this.$_executeApi('post', `invoices/share/${this.creditNoteObj.id}`, model)
              .then((result) => {
                if (result.data && result.data.status === 500) {
                  this.$parent.$parent.mailOrEHF = 1
                  this.$parent.$parent.invoiceIssueModal = true
                }
                if (result.data) {
                  const { invoice } = result.data
                  if (invoice) {
                    let transformData = { date: { list: ['invoice_date', 'due_date', 'completed_date'], from: 'DD.MM.YYYYTHH:mm:ss', to: 'DD.MM.YYYY' }, number: { list: ['total_sum', 'grand_total', 'invoiceTotal', 'rounding_value' , 'dg_percentage'], format: 'replaceCommaWithDot' } }
                    let model = this.$formatter.cloneVariable(invoice)
                    model = this.$_formatModel(model, transformData)
                    this.creditNoteObj = model
                  }
                }
              })
          }
        }).finally(() => {
          this.previewLoader = false
        })
    },
    getInvoiceReportContent () {
      return this.exportToNordea([this.creditNoteObj.id || 0], '', true, [])
    },
    async saveAsHandler (type, emailIds) {
      if (this.$refs.invoiceForm.validate()) {
        if (type === 4 && !emailIds) {
          var emailId = ''
          this.isResend = false
          let result = this.listOfCustomers.find(x => x.id === this.creditNoteObj.customer_id)
          if (result) emailId = result.invoiceemail ? result.invoiceemail : ''
          this.emailIds = emailId
          this.shareDialog = true
        } else {
          this.saveLoader = true
          let invoiceModel = this.$formatter.cloneVariable(this.creditNoteObj)
          invoiceModel.invoice_date = `${invoiceModel.invoice_date}T${moment().format('HH:mm:ss')}`
          let transformData = { date: { list: ['invoice_date', 'due_date', 'completed_date'], from: 'DD.MM.YYYYTHH:mm:ss', to: 'MM.DD.YYYY' } }
          let model = this.$formatter.cloneVariable(invoiceModel)
          model.total_sum = this.$formatter.replaceCommaWithDot(this.totalValues.sum)
          model.grand_total = this.$formatter.replaceCommaWithDot(this.totalValues.invoiceTotal)
          model.rounding_value = this.$formatter.replaceCommaWithDot(this.totalValues.rounding_value)
          model.dg_percentage = this.$formatter.replaceCommaWithDot(this.totalValues.dg_percentage)
          model.type = 2
          model.completion_type = 0
          if (this.$route.query.invoice_id) {
            model.number = ''
            model.invoice_ref = this.$route.query.invoice_id
          }
          model = this.$_formatModel(model, transformData)
          switch (type) {
            case 1: // Save as Draft
              model.completion_type = 1
              model.status = 'draft'
              break
            case 2: // Save and Download
              model.completion_type = 2
              model.status = 'completed'
              break
            case 3: // Save and Use EHF
              model.completion_type = 3
              model.status = 'completed'
              break
            case 4: // Save and Send
              model.completion_type = 4
              model.status = 'completed'
              break
            default:
              break
          }
          this.$_saveUpdateHandler(this.MODULE, model).then(async (response) => {
            if (this.listOfInvoiceItems.length > 0) {
              try {
                await this.saveOrUpdateInvoiceItems(response.id, type)
              } catch (err) {
                this.saveLoader = false
                return
              }
              this.creditNoteObj.id = response.id
              this.creditNoteObj.number = response.number
              if (type === 4) {
                this.shareDialog = false
                await this.sendEmailHandler(emailIds)
              } else if (type === 2) await this.downloadInvoice()
              else if (type === 3) {
                let getBase64Content = await this.getInvoiceReportContent()
                const customer = this.creditNoteObj.customerdata ? JSON.parse(this.creditNoteObj.customerdata || {}) : {}
                const customerLang = customer.Language ? customer.Language : this.$i18n.locale
                let lang = this.$i18n.messages[customerLang].message
                let model = { content: getBase64Content, filename: `${lang.invoice.creditNote}_${this.creditNoteObj.number || ''}.pdf` }
                this.$_executeApi('post', `invoices/generate_pdf/${this.creditNoteObj.id}`, model)
                  .then(async (response) => {
                    let fileName = response.data
                    let ehfModel = { id: this.creditNoteObj.id, type: 2, attachment_filename: fileName }
                    await this.generateEHFReport(ehfModel)
                  })
              }
              if (!model.id) {
                this.$router.push(`/orders/edit/${this.$route.params.order_id}/invoice/creditnote/${response.id}`)
              } else this.getSingleRecordHandler()
              this.saveLoader = false
              this.$store.commit('isChangesMade', false)
            }
          }).catch(() => {
            this.saveLoader = false
          })
        }
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    },
    saveAndEmailHandler () {
      if (this.$refs.shareForm.validate() && this.emailIds) {
        if (this.emailIds) this.isValidEmail = true
        const getMailIDsString = this.emailIds
        const listOfMailIds = getMailIDsString.split(',')
        if (listOfMailIds.length > 0) {
          for (let i = 0; i < listOfMailIds.length; i++) {
            if (listOfMailIds[i]) {
              listOfMailIds[i] = listOfMailIds[i].trim()
              if (this.validEmail(listOfMailIds[i])) this.isValidEmail = false
              else this.isValidEmail = true
            }
          }
        }
        if (!this.isValidEmail) {
          this.saveAsHandler(4, listOfMailIds)
        } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    },
    /* eslint-disable */
    validEmail: function (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },
    isShowResendEhf () {
      let result = this.listOfCustomers.find(x => x.id === this.creditNoteObj.customer_id)
      if (result) return result.paymentmethod2 === '2' && this.creditNoteObj.completion_type === 3 ? true : false
    },
    isShowResendEmail () {
      let result = this.listOfCustomers.find(x => x.id === this.creditNoteObj.customer_id)
      if (result) return result.paymentmethod2 === '2' && (this.creditNoteObj.completion_type === 4 || this.creditNoteObj.completion_type === 2) ? true : false
    },
    ehfWarningHandler () {
      this.ehfWarningObj = {
        dialog: true,
        loading: false,
        onSuccess: async () => {
          this.ehfWarningObj.loading = true
          await this.resendEhf()
          this.ehfWarningObj.dialog = false
          this.ehfWarningObj.loading = false
        },
        onCancel: () => {
          this.ehfWarningObj.dialog = false
        }
      }
    },
    async resendEhf () {
      this.ehfLoader = true
      let getBase64Content = await this.getInvoiceReportContent()
      const customer = this.creditNoteObj.customerdata ? JSON.parse(this.creditNoteObj.customerdata || {}) : {}
      const customerLang = customer.Language ? customer.Language : this.$i18n.locale
      let lang = this.$i18n.messages[customerLang].message
      let model = { content: getBase64Content, filename: `${lang.invoice.creditNote}_${this.creditNoteObj.number || ''}.pdf` }
      this.$_executeApi('post', `invoices/generate_pdf/${this.creditNoteObj.id}`, model)
        .then(async (response) => {
          let fileName = response.data
          let ehfModel = { id: this.creditNoteObj.id, type: 2, attachment_filename: fileName }
          await this.generateEHFReport(ehfModel, true)
        })
    },
    generateEHFReport (ehfModel, fromResend) {
      return this.$_executeApi('post', `${this.MODULE}/generate_ehf`, ehfModel)
        .then(resposnse => {
          if (resposnse.data && resposnse.data.status === 500) {
            this.$parent.$parent.mailOrEHF = 2
            this.$parent.$parent.invoiceIssueModal = true
          }
          if (fromResend) {
            this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.invoice.ehfInfo') })
            this.ehfLoader = false
          }
          this.getSingleRecordHandler()
        })
    },
    saveOrUpdateInvoiceItems (invoiceId, type) {
      let invoiceItemsModel = this.$formatter.cloneVariable(this.listOfInvoiceItems)
      invoiceItemsModel.forEach((element, index) => {
        element.id = (this.initSaveWithIds || this.$route.query.materials || this.$route.params.invoice_id) ? element.id : 0
        element.qty = parseFloat(this.$formatter.replaceCommaWithDot(element.qty))
        element.dg = parseFloat(this.$formatter.replaceCommaWithDot(element.dg))
        element.discount = parseFloat(this.$formatter.replaceCommaWithDot(element.discount))
        element.net_price = parseFloat(this.$formatter.replaceCommaWithDot(element.net_price))
        element.base_price = parseFloat(this.$formatter.replaceCommaWithDot(element.base_price))
        element.sum_ex_vat = parseFloat(this.$formatter.replaceCommaWithDot(element.sum_ex_vat))
        element.price = parseFloat(this.$formatter.replaceCommaWithDot(element.price))
        element.cost = parseFloat(this.$formatter.replaceCommaWithDot(element.cost))
        element.db = parseFloat(this.$formatter.replaceCommaWithDot(element.db))
      })
      invoiceItemsModel.forEach(item => {
        item.invoice_id = undefined
      })
      let invoiceItemsJSON = { 'items': this.$formatter.cloneVariable(invoiceItemsModel) }
      let url = 'bulk_save'
      if (this.initSaveWithIds) {
        url = 'bulk_save_for_creditnote'
        this.initSaveWithIds = false
      }
      return this.$_executeApi('post', `invoiceitems/${url}/${invoiceId}`, invoiceItemsJSON)
        .catch((err) => {
          this.errorMessage = (err && err.response && err.response.data && err.response.data.message) || (err && err.response && err.response.data) || (err && err.message) || 'An error occurred while saving credit note items'
          this.errorDialog = true
          throw err
        })
    },
    getInvoiceSettings () {
      this.$_getSingleRecordHandler('invoicesettings')
        .then((result) => {
          if (result.data) this.settingsObj = result.data
        })
    },
    getListHandler () { },
    addNewProduct () {
      let obj = { loading: false, products: [], newproduct: true, isextrarow: true, qty: 0, dg: 0, discount: 0, net_price: 0, base_price: 0, sum_ex_vat: 0, price: 0, cost: 0, db: 0 }
      let transformData = { number: { list: ['qty', 'dg', 'discount', 'net_price', 'base_price', 'sum_ex_vat', 'price', 'cost', 'db'], format: 'replaceDotWithComma' } }
      obj = this.$_formatModel(obj, transformData)
      this.listOfInvoiceItems.push(obj)
    },
    toggleAllProducts (index, action, productId) {
      let items = this.$formatter.cloneVariable(this.listOfInvoiceItems)
      if (action === this.HIDE) {
        let products = items[index].products.filter(x => x.id === productId)
        items[index].products = products
      }
      this.$set(this.listOfInvoiceItems, index, items[index])
    },
    // Searching products
    loadProducts (term, index, event) {
      if ([30, 32, 37, 38, 39, 40].indexOf(event.keyCode) > -1) return
      let searchText = this.$refs[term][0].lazySearch
      if (searchText !== null) {
        this.productsLoading = true
        let model = {
          'expand': [{
            'select': ['id', 'name'],
            'model': 'ProductUnit',
            'on_field': 'id',
            'on_parent_field': 'unitid'
          }],
          'filter': `number contains '${searchText}' OR name contains '${searchText}'`,
          'additionalfilters': [`isactive eq 1`],
          'skip': 0,
          'limit': 50,
          'order_by': {
            'field': 'number',
            'asc_or_desc': 'asc'
          }
        }
        this.$_executeApi('post', 'products/query', model).then((response) => {
          if (!this.listOfInvoiceItems[index].products) this.listOfInvoiceItems[index].products = []
          this.listOfInvoiceItems[index].products = []
          if (response.data.length > 0) {
            response.data = response.data.filter(x => !x.isdeleted)
            response.data.forEach(element => {
              element.productName = element.number ? `${element.number} - ${element.name}` : element.name
            })
            this.$set(this.listOfInvoiceItems[index], 'products', response.data)
          }
          this.productsLoading = false
        })
      }
    },
    async setProductValues (index, product) {
      let element = this.listOfInvoiceItems[index]
      if ((typeof product) === 'string') {
        element.productset = true
        element.product_number = product
        element.productnumber = element.product_number
        if (element.productset) this.$set(this.listOfInvoiceItems, index, element)
      } else if (product) {
        element.loading = true
        // set prices
        let exchangeAmt = 0
        if (this.exchangeRate) exchangeAmt = this.exchangeRate
        let getDiscount = await this.getDiscountValue(product.id)
        // get sales price value from customer matrix
        let salesPriceFromCustomer = product.salesprice
        getDiscount = getDiscount && getDiscount.data ? getDiscount.data : {}
        let discountForProduct = product.ispackage ? '' : (getDiscount && getDiscount.discount ? this.$formatter.replaceDotWithComma(getDiscount.discount) : '')
        const getSalesPrice = await this.getCustomerPrice(product, discountForProduct)
        if (getSalesPrice) {
          salesPriceFromCustomer = getSalesPrice.price
          discountForProduct = getSalesPrice.discount || 0
        }
        element.productset = true
        element.product_id = product.id
        element.product_number = product.number
        element.description = product.name
        // set unit and vat values
        element.unit_id = product.productunit_id || product.unitid
        if (element.unit_id) {
          let unitObj = this.listOfUnits.find(x => x.id === element.unit_id)
          element.productunitname = unitObj ? unitObj.name : ''
        }
        element.vat = product.vatid

        element.net_price = this.$formatter.replaceDotWithComma(product.costprice)
        element.base_price = this.$formatter.replaceDotWithComma(salesPriceFromCustomer)
        element.discount = this.$formatter.replaceDotWithComma(discountForProduct)
        if (element.productset) this.$set(this.listOfInvoiceItems, index, element)
        element.loading = false
      }
      // if (element.productset) this.$set(this.listOfInvoiceItems, index, element)
    },
    resetToprojectSelect (index, element, ref) {
      if (!element.product_number) {
        element.productset = false
        element.product = null
        // element.description = ''
        this.$set(this.listOfInvoiceItems, index, element)
        setTimeout(() => {
          if (this.$refs[ref] && this.$refs[ref][0]) this.$refs[ref][0].focus()
        }, 50)
      }
    },
    deleteRow (index) {
      let self = this
      self.$store.commit('showDeleteDialog', {
        isLocalDelete: true,
        dialogOkCb: () => {
          self.listOfInvoiceItems.splice(index, 1)
          self.calculateAllValues()
        }
      })
    },
    hideAndShowComments (element, index) {
      let model = this.listOfInvoiceItems[index]
      model.show_comments = !model.show_comments
      this.$set(this.listOfInvoiceItems, index, model)
    },
    getDiscountValue (productId) {
      return this.$_executeApi('get', `discountgroups/get_by_product_for_order/${productId}?order_id=${this.creditNoteObj.order_id}`)
    },
    getCustomerPrice (product, discount) {
      return new Promise((resolve, reject) => {
        this.$_executeApi('get', `customernetprices/get_for_sale_order/${this.creditNoteObj.order_id}/${product.id}`)
          .then((result) => {
            let model = result.data
            if (model && model.salesprice) {
              if (model.salesprice > product.costprice) resolve({ price: model.salesprice, discount: '' })
              else resolve({ price: product.costprice, discount })
            } else {
              resolve({ price: product.salesprice, discount })
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    getExchangeRate (currencyId) {
      return new Promise((resolve, reject) => {
        this.$_executeApi('get', `currencies/get_exchange_rate/${currencyId}`)
          .then((result) => {
            this.exchangeRate = result.data
            resolve(result)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    getAllDocumentsFromSharepointForShare (id) {
      this.attachmentSharepointObj.loading = true
      this.$_executeApi('get', `sharepoint/get_children_documents/${id}`)
        .then((response) => {
          if (response) {
            var files = response.data || []
            this.attachmentSharepointObj.files = files
          }
        })
        .finally(() => {
          this.attachmentSharepointObj.loading = false
        })
    },
    closeShareDialog () {
      this.emailIds = ''
      this.shareDialog = false
    },
    syncToErp () {
      this.syncToErpLoading = true
      this.$_executeApi('post', 'invoices/sync_to_24seven', { ids: [this.creditNoteObj.id] })
        .then((response) => {
          this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: 'Credit note synced to ERP successfully' })
          this.getSingleRecordHandler()
        })
        .catch((err) => {
          const errorMsg = (err && err.response && err.response.data && err.response.data.message) || (err && err.response && err.response.data) || (err && err.message) || 'Failed to sync credit note to ERP'
          this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: errorMsg })
        })
        .finally(() => {
          this.syncToErpLoading = false
        })
    },
    closeErrorDialog () {
      this.errorDialog = false
      this.errorMessage = ''
      window.location.reload()
    }
  },
  beforeRouteLeave (to, from, next) {
    if (!this.$store.state.isChangesMade) {
      next()
    } else {
      this.$store.commit('isChangesMade', true)
      this.$store.commit('changeLostDialog', true)
    }
  },
  destroyed () {
    if (this.partialCreditIds) window.localStorage.removeItem('#credit_note_select_products')
  },
}
</script>
<style>
  .align-right input {
    text-align: right !important;
  }
  .dense_table .v-text-field--full-width input {
  margin-top: 0!important;
}
.dense_table .v-text-field--full-width > .v-input__control > .v-input__slot {
  min-height: auto !important;
}
.dense_table .v-text-field.v-text-field--enclosed > .v-input__control > .v-input__slot {
  padding: 0 !important;
  font-size: 14px;
}
.invoiceProducts .v-text-field {
  padding-top: 0px !important;
  margin-top: 0px !important;
}
.invoiceProducts th, .invoiceProducts td {
  padding: 2px !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
}
.invoiceProducts textarea {
  margin-top: 2px !important;
}
.invoiceProducts .v-input {
  font-size: 14px !important;
}
.invoiceProducts.v-data-table tbody tr:hover:not(.v-data-table__expanded__content) {
  background-color: inherit;
}
.invoiceProducts .v-text-field--full-width .v-input__append-inner {
  margin-top: 4px !important;
}
/*  */
.credit_note_comment div.v-text-field__slot > textarea {
  padding-left: 4px;
}
</style>
